import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import UserNavigator from "../../../navigation/UserNavigator";
import styles from "./userSettings.module.css";

const UserSettings = () => {
  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/users/show-all-users">
              عرض جميع اللاعبين
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/users/search-one-user">
              البحث عن لاعب
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/users/edit-users-images">
              التحكم في صور اللاعبين
            </PageLink>
          </div>
        </div>
      </HorizantalBar>
      <UserNavigator />
    </div>
  );
};

export default UserSettings;
